import { useModal } from './ModalContext'
import Link from '@commons/link/Link.tsx'
import { Link as LinkProps } from '@commons/drupal.types'

type ModalTriggerProps = {
    onClick?: () => void
} & LinkProps

const ModalTrigger = ({ onClick, ...props }: ModalTriggerProps) => {
    const { open } = useModal()

    if (!props?.label?.trim()) return null

    return (
        <Link
            {...props}
            onClick={e => {
                e.preventDefault()
                open()
                onClick?.()
            }}
            data-testid="modal-trigger"
        />
    )
}

export default ModalTrigger
